export default "__VITE_ASSET__DoC_3Izh__"